// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4598":"f475f12a","5539":"c0bc8e52"}[chunkId] + ".chunk.css";
};